import React from 'react';
import { FormattedHTMLMessage, injectIntl } from 'react-intl';
import { Modal } from 'sa-ui';

import messages from './composingCorrectionTermsOfUseModalMessages';

function getContent(intl) {
  switch (intl.locale.toUpperCase()) {
    case 'PT':
      return `
      <div class="text-left">
      <p><span class="text-warning">Importante! </span>Para que o processo de correção das folhas de redação ocorra sem problemas, estou ciente que:</p>
      <p><strong>1. A impressão das folhas de redação devem seguir as configurações abaixo:</strong></p>
      <ul>
          <li>Cor da impressão: Preto e Branco</li>
          <li>Modo da impressão: Laser e normal (NUNCA modo rascunho)</li>
          <li>Papel: branco e no tamanho A4;</li>
          <li>Por favor, imprimir apenas uma ficha por folha (NUNCA use frente e verso)</li>
      </ul>
      <p><strong>2. A digitalização das folhas de redação devem seguir as configurações abaixo:</strong></p>
      <ul>
          <li>Resolução mínima: 300 dpi e em escala de cinza</li>
          <li>Posição: vertical</li>
          <li>Tipo de arquivo: .JPEG ou .PNG</li>
          <li>Todas as imagens devem estar alinhadas e com o cabeçalho para cima</li>
          <li>Cada arquivo deve conter apenas um cartão-resposta</li>
          <li>Fichas em branco NÃO devem ser enviadas</li>
      </ul>
      <p>Os arquivos que NÃO seguirem os padrões estabelecidos acima não serão corrigidos e deverão ser validados pela própria escola e reenviados no card do seu respectivo simulado.</p>
  </div>
  `;
    default:
      return `
     
1.270 / 5.000
Resultados de tradução
Resultado da tradução
<div class="text-left">
 <p><span class="text-warning">Important! </span>In order for the process of correcting the essay sheets to go smoothly, I am aware that:</p>
 <p><strong>1. The printing of essay sheets must follow the settings below:</strong></p>
 <ul>
 <li>Printing color: Black and White</li>
 <li>Print mode: Laser and normal (NEVER draft mode)</li>
 <li>Paper: white and A4 size;</li>
 <li>Please print only one card per sheet (NEVER use double-sided)</li>
 </ul>
 <p><strong>2. The scanning of writing sheets must follow the settings below:</strong></p>
 <ul>
 <li>Minimum resolution: 300 dpi and in grayscale</li>
 <li>Position: vertical</li>
 <li>File type: .JPEG or .PNG</li> 
 <li>All images must be aligned and with the header facing up</li>
 <li>Each file must contain only one reply card</li>
 <li>Blank forms should NOT be sent</li>
 </ul>
 <p>Files that DO NOT follow the standards established above will not be corrected and must be validated by the school itself and resent in the respective simulation card.</p>
 </div>
        `;
  }
}

function SimulatedCorrectionTermsOfUseModal(props) {
  const closeButton = {
    label: props.intl.formatMessage(messages.back),
    onClick: props.onClose,
  };
  const continueButton = {
    label: props.intl.formatMessage(messages.agreeAndContinue),
    onClick: props.onContinue,
    primary: true,
  };
  const buttons = [closeButton, continueButton];
  return (
    <Modal
      show={props.show}
      onClose={props.onClose}
      icon="icon ti-marker-alt"
      title={props.intl.formatMessage(messages.title)}
      buttons={buttons}
    >
      <div className="text-left" dangerouslySetInnerHTML={{ __html: getContent(props.intl) }} />
    </Modal>
  );
}

export default injectIntl(SimulatedCorrectionTermsOfUseModal);
